import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { EventsApiBase } from '../mcap-events/api-base';
import { BlobFileSasUrl } from '../../models/blob-file-sas-url.model';
import { PreviewDocumentModel } from '../../models/event-poe-document.model';

@Injectable({
  providedIn: 'root'
})
export class DocumentPreviewService extends EventsApiBase {
  getPreviewFileContent<T extends PreviewDocumentModel>(documentModel: T): any {
    return this.getFileSasUrl(documentModel).pipe(
      mergeMap(blolFileSasUrl =>
        this.http.get(blolFileSasUrl, { responseType: 'blob' })
      )
    );
  }

  getFileSasUrl<T extends PreviewDocumentModel>(
    document: T
  ): Observable<string> {
    return this.post<T, BlobFileSasUrl>(document.apiUri, document, {}).pipe(
      map(s => s.blobUrl + s.sasToken)
    );
  }
}
